import { css } from 'styled-components';

export const apTheme = css`
    --color-primary: #00259D;

    --color-state-primary: rgba(0, 37, 157, 0.07);
    --color-state-secondary: rgba(0, 37, 157, 0.24);
    --color-state-tertiary: rgba(48, 49, 48, 0.07);

    --color-outline: #000724;

    /* Home Page */
    --home-hero-background: linear-gradient(239deg, #001874 0%, #00259D 100%);
    --home-hero-title-color: white;
    --home-hero-subtitle-color: white;

    /* Subscription Page */
    --subscription-hero-background: #DFE3FC;
    --subscription-hero-title-color: black;
    --subscription-hero-subtitle-color: black;

    /* User Shortcuts */
    --color-outline-accent: var(--color-primary);
`;
